<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
    <li :key="item.id" v-for="item in data">
      <div :class="`bg-${item.color}`" class="timeline-icon">
        <vs-icon :icon-pack="item.iconPack" :icon="item.icon" size="small" class="text-white w-7 h-7"/>
      </div>
      <div class="timeline-info">
        <p class="font-semibold">{{ $t(prefix + item.title) }}</p>
        <span class="activity-desc">{{ item.desc }}</span>
      </div>
      <small class="text-grey activity-e-time">{{ item.time }}</small>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'vx-timeline',
  props: {
    data: {
      type: Array,
      required: true
    },
    prefix: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
